<template>
  <el-footer height="4rem" class="el-footer" style="padding-left: 0;">2021 Created by 北京瀚禹信息科技有限公司</el-footer>
</template>

<script>
export default {
  
}
</script>

<style scoped lang="less">
.el-footer{
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #B1B1B1;
}
</style>
